export const BackendOption = {
  AFFIRMATIVE: 'success',
  APPLICATION_MODULE: 'success',
  APPLIED: 'success',
  CANCELED_BY_CYCLE: 'fail',
  CANCELED_OVERRIDE: 'fail',
  CANCELED: 'fail',
  CLOSED: 'fail',
  DISCARDED: 'fail',
  DISPENSED: 'success',
  DOES_NOT_APPLY: 'info',
  EPS: 'info',
  ERROR_REPORT: 'fail',
  ERROR: 'fail',
  FINALIZED_WITH_ERROR: 'fail',
  FINALIZED: 'success',
  FINISHED_REPORT: 'success',
  FINISHED: 'success',
  IN_MANAGEMENT: 'info',
  INACTIVE: 'fail',
  INITIALIZED: 'info',
  INITIATED: 'info',
  INVOICED_PRINTED: 'success',
  MAKING_REPORT: 'info',
  MANAGED: 'success',
  MASSIVE_LOAD: 'info',
  NEGATIVE: 'fail',
  NOT_PBS: 'success',
  OCCUPIED: 'fail',
  OPEN: 'info',
  PAC: 'success',
  PARTICULAR: 'warning',
  PATIENT_MODULE: 'success',
  PBS: 'fail',
  PENDING: 'warning',
  PROCESING: 'warning',
  PROCESSED: 'success',
  RECEIVED: 'success',
  RESCHEDULED: 'warning',
  RESOLVED: 'success',
  RETURNED: 'fail',
  SCHEDULED: 'success',
  SENDING_REPORT: 'info',
  TO_BE_CANCELED: 'fail',
  UNKNOWN: 'warning',
  UNMANAGED: 'info',
  VALIDATING: 'info',
  WAITING: 'info',
  WRITING_REPORT: 'info'
};
